import React from "react";

// Operations features other than Tasks and My Tasks are complimentary through
// the end of 2026. Task access is handled separately and does not use this
// subscription helper.
export const OPS_COMPLIMENTARY_ACCESS_END = new Date(2027, 0, 1);

export const hasSubscription = (account, subscriptionName) => {
  const flags = account?.flags || [];
  return flags.some((flag) => flag?.name === subscriptionName);
};

export const hasOpsSubscription = (account, now = new Date()) => {
  return (
    now < OPS_COMPLIMENTARY_ACCESS_END ||
    hasSubscription(account, "ops-subscription")
  );
};

export const hasCRMSubscription = (account) => {
  return hasSubscription(account, "crm-subscription");
};

export const SubscriptionRequiredNotice = ({ featureName }) => {
  return (
    <div className="uk-alert">
      {featureName} Subscription Required. Contact RueBaRue support to enable
      this feature.
    </div>
  );
};

const OpsSubscriptionRequired = () => {
  return <SubscriptionRequiredNotice featureName="Ops" />;
};

export const CRMSubscriptionRequired = () => {
  return <SubscriptionRequiredNotice featureName="CRM" />;
};

export default OpsSubscriptionRequired;
